import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const ThreePLQuotaRolesRBAC = {
  pageID: '48cccec2a403b20fe3de8aaf645b46a5',
  elementID: {
    viewHubList: 'ab3dede1e800f25b6d08944cee482686',
    viewAllocationHistory: '76a94906def2e9a1a1e0fab3b19668df',
    allowManualAddQuota: 'ff18529c10e7dd78f307cfda6f8ec804',
    allowAtur3PLQuota: '859336e684019385c4f82369dac09602',
  },
} as const

export const useThreePLQuotaRBACPage = createUseRBAC(ThreePLQuotaRolesRBAC.elementID)

export type UseThreePLQuotaRBACType = ReturnType<typeof useThreePLQuotaRBACPage>
